import * as React from 'react';

import {IntegrationWidget} from 'shells/integration-widget/integration-widget';
import {LabelWithContent} from 'shells/typography/label-with-content';

import type {ExternalServiceType} from 'nutshell-graphql-types';
import type {GetSessionUser_loggedInUser as User} from 'nutshell-graphql-types';

import {getServiceTypeIcon, getStatusMessage} from '../helpers';
import {TranscriptionModePicker} from '../transcription-mode-picker';

import styles from './meetings-table.module.css';

type Props = {
    isEnabled: boolean;
    userEmail: string;
    onConnectClick: () => void;
    onDisconnectClick: () => void;
    serviceType: ExternalServiceType;
    user: User;
};

export function SettingsTab(props: Props) {
    const Icon = getServiceTypeIcon(props.serviceType);

    return (
        <div className='flex flex-dir-col gap-32 pad-16'>
            <LabelWithContent
                label='Account'
                spacing={8}
                content={
                    <div className={styles['integration-widget-container']}>
                        <IntegrationWidget
                            account={props.userEmail}
                            actionStyle={props.serviceType === 'GOOGLE_MEET' ? 'switch' : 'button'}
                            status={props.isEnabled ? 'enabled' : 'disabled'}
                            logo={Icon}
                            onConnectClick={props.onConnectClick}
                            onDisconnectClick={props.onDisconnectClick}
                            onlyDisconnect={true}
                            statusMessage={getStatusMessage(props.isEnabled, props.serviceType)}
                        />
                    </div>
                }
            />
            <TranscriptionModePicker serviceType={props.serviceType} user={props.user} />
        </div>
    );
}
